import colors from '../../../themes/colors';
export default function getCellColor(props) {
    var _a, _b;
    var cellArgs = props.cellArgs, config = props.config;
    var row = cellArgs.row, rowIndex = cellArgs.rowIndex;
    var rowColor = (_a = config === null || config === void 0 ? void 0 : config.rowColor) === null || _a === void 0 ? void 0 : _a.call(config, row, rowIndex);
    var cellColor = (_b = config === null || config === void 0 ? void 0 : config.cellColor) === null || _b === void 0 ? void 0 : _b.call(config, cellArgs);
    var bgColor = rowColor !== null && rowColor !== void 0 ? rowColor : cellColor;
    var color;
    if (bgColor) {
        if (bgColor in colors) {
            color = colors[bgColor];
        }
        else {
            color = bgColor;
        }
        /* not sure about this, but will revisit in the future */
        return "".concat(color, " !important");
    }
    return undefined;
}
